"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const native_1 = require("@react-navigation/native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const icon_1 = __importDefault(require("../../components/icon/icon"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const styles_1 = __importDefault(require("../../styles/styles"));
const screenConstants_1 = require("../../constants/screenConstants");
const typesConstants_1 = require("../../constants/typesConstants");
const pressable_1 = __importDefault(require("../../components/pressable/pressable"));
const eventConstants_1 = require("../../constants/eventConstants");
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const messageComponent_1 = __importDefault(require("../../components/messageComponent/messageComponent"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const audioPlayer_1 = __importDefault(require("../../components/audioComponent/audioPlayer"));
const qualityAssuranceSlice_1 = require("./qualityAssuranceSlice");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const colors_1 = __importDefault(require("../../styles/colors"));
const constants_1 = require("../../constants/constants");
const auditSummary_1 = __importDefault(require("../../components/auditComponent/auditSummary"));
const auditForm_1 = __importDefault(require("../../components/auditComponent/auditForm"));
const ticketSlice_1 = require("../ticket/ticketSlice");
const ticketsModal_1 = __importDefault(require("../../components/ticketComponent/ticketsModal"));
const scheduleActionsModal_1 = __importDefault(require("../../components/scheduleActions/scheduleActionsModal"));
const actionsSlice_1 = require("../actions/actionsSlice");
const filterScehduleActionsConstants_1 = require("../../components/filterScheduleActions/filterScehduleActionsConstants");
const Audit = () => {
    const dispatch = useAppDispatch_1.default();
    const navigator = native_1.useNavigation();
    const isDesktop = useWebDesktopDesign_1.default();
    const route = native_1.useRoute();
    const { callRecords, loadingStatus, errorMessage, selectedCallRecordIndex, selectedCallRecordAudit } = useAppSelector_1.default((state) => ({
        callRecords: state.qualityAssurance.callRecords,
        selectedCallRecordIndex: state.qualityAssurance.selectedCallRecordIndex,
        loadingStatus: state.qualityAssurance.loadingStatus,
        selectedCallRecordAudit: state.qualityAssurance.selectedCallRecordAudit,
        errorMessage: state.qualityAssurance.errorMessage,
    }));
    const [showTickets, setShowTickets] = react_1.useState(false);
    const [showScheduleActions, setShowScheduleActions] = react_1.useState(false);
    const containerStyle = isDesktop ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile;
    const callRecordID = route.params && route.params.call_record_id;
    const callRecord = callRecords[selectedCallRecordIndex != null ? selectedCallRecordIndex : -1];
    const onTicketsPageChange = (page) => {
        dispatch(ticketSlice_1.getCallDetailRecordTickets({ call_detail_record_id: callRecordID, page }));
    };
    react_1.useEffect(() => {
        dispatch(ticketSlice_1.getCallDetailRecordTickets({ call_detail_record_id: callRecordID }));
    }, [callRecordID]);
    const onScheduleActionsPageChange = (page) => {
        dispatch(actionsSlice_1.getScheduleActions({ notes_availability: filterScehduleActionsConstants_1.CALL_LOG_WITH_NOTES, schedule_id: callRecord.schedule_id, page }));
    };
    // Get all agent notes associated with the call record's schedule.
    react_1.useEffect(() => {
        if (callRecord) {
            dispatch(actionsSlice_1.getScheduleActions({ notes_availability: filterScehduleActionsConstants_1.CALL_LOG_WITH_NOTES, schedule_id: callRecord.schedule_id }));
        }
    }, [callRecord]);
    react_1.useEffect(() => {
        const callRecordIndex = callRecords.findIndex((obj) => obj.id === callRecordID);
        if (callRecordIndex === -1) {
            navigator.navigate(screenConstants_1.QUALITY_ASSURANCE_SCREEN, { call_record_id: callRecordID });
            return;
        }
        if (callRecordIndex !== selectedCallRecordIndex) {
            dispatch(qualityAssuranceSlice_1.setSelectedCallRecordIndex(callRecordIndex));
        }
        // Always get the latest version of audit.
        dispatch(qualityAssuranceSlice_1.getCallDetailRecordAudit({ call_detail_record: callRecordID }));
    }, [callRecordID]);
    const renderContent = () => {
        // Return early is no call record.
        if (!callRecord) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        if (loadingStatus === typesConstants_1.PENDING_STATUS) {
            return react_1.default.createElement(spinner_1.default, null);
        }
        if (loadingStatus === typesConstants_1.SUCCEEDED_STATUS || (loadingStatus === typesConstants_1.FAILED_STATUS && errorMessage === constants_1.NOT_FOUND)) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                !!callRecord.record && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, styles_1.default.flexOne, styles_1.default.blueBackground] },
                    react_1.default.createElement(audioPlayer_1.default, { multi: false }))),
                react_1.default.createElement(auditSummary_1.default, { callDetailRecordAudit: selectedCallRecordAudit, callRecord: callRecord }),
                react_1.default.createElement(auditForm_1.default, { callRecord: callRecord, callDetailRecordAudit: selectedCallRecordAudit })));
        }
        return (react_1.default.createElement(messageComponent_1.default, { message: errorMessage || 'An error occurred.', color: colors_1.default.RED, icon: free_solid_svg_icons_1.faExclamationCircle }));
    };
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: [containerStyle, styles_1.default.marginBottomTwenty] },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                    react_1.default.createElement(boxTitle_1.default, { title: "Audit Call Record" })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(pressable_1.default, { onPress: () => navigator.navigate(screenConstants_1.QUALITY_ASSURANCE_SCREEN), style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: eventConstants_1.NAVIGATE_HOME_BUTTON },
                            react_1.default.createElement(react_native_1.View, null,
                                react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faArrowLeft })),
                            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                                react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, ` Call Records `)))))),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow] },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignSpaceBetween, styles_1.default.flexDirectionRow, styles_1.default.marginTen] },
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.flexDirectionRow] },
                        react_1.default.createElement(react_native_paper_1.Button, { buttonColor: colors_1.default.BLUE, textColor: colors_1.default.WHITE, icon: "file-search", onPress: () => setShowTickets(!showTickets), style: styles_1.default.marginRightTen }, showTickets ? 'Close Tickets' : 'Show Tickets'))),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignSpaceBetween, styles_1.default.flexDirectionRow, styles_1.default.marginTen] },
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.flexDirectionRow] },
                        react_1.default.createElement(react_native_paper_1.Button, { buttonColor: colors_1.default.BLUE, textColor: colors_1.default.WHITE, icon: "file-search", onPress: () => setShowScheduleActions(!showScheduleActions), style: styles_1.default.marginRightTen }, showTickets ? 'Close Schedule Actions' : 'Show Scheudle Actions')))),
            react_1.default.createElement(react_native_1.View, null, renderContent())),
        react_1.default.createElement(ticketsModal_1.default, { visible: showTickets, hideModal: () => setShowTickets(false), onPageChange: onTicketsPageChange }),
        react_1.default.createElement(scheduleActionsModal_1.default, { visible: showScheduleActions, hideModal: () => setShowScheduleActions(false), onPageChange: onScheduleActionsPageChange })));
};
exports.default = Audit;
